// extracted by css-extract-rspack-plugin
export default {"requirement":"requirement-IOfP10","dots":"dots-ysLMNT"};